module.exports = __webpack_public_path__ + "static/media/business_icon.f0675238.svg";